import request from '@/axios'
import type { UserType, LoginResult } from './types'
import { logoutAdminSession } from '@/utils/adminSession'

interface RoleParams {
  roleName: string
}

export const loginApi = (data: UserType): Promise<IResponse<LoginResult>> => {
  return request.post({ url: '/adminApi/auth/login', data })
}

// 延迟读取会话模块，避免 user → login API → axios → session 的循环导入捕获未初始化值。
export const loginOutApi = () => logoutAdminSession()

export const getUserListApi = ({ params }: AxiosConfig) => {
  return request.get<{
    code: string
    data: {
      list: UserType[]
      total: number
    }
  }>({ url: '/mock/user/list', params })
}

export const getAdminRoleApi = (
  params: RoleParams
): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.get({ url: '/mock/role/list', params })
}

export const getTestRoleApi = (params: RoleParams): Promise<IResponse<string[]>> => {
  return request.get({ url: '/mock/role/list2', params })
}
